"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VismaAccountType = exports.VismaBankAccountType = void 0;
var VismaBankAccountType;
(function (VismaBankAccountType) {
    VismaBankAccountType[VismaBankAccountType["NONE"] = 0] = "NONE";
    VismaBankAccountType[VismaBankAccountType["ChequeAccount"] = 1] = "ChequeAccount";
    VismaBankAccountType[VismaBankAccountType["CashAccount"] = 2] = "CashAccount";
    VismaBankAccountType[VismaBankAccountType["SavingsAccount"] = 3] = "SavingsAccount";
    VismaBankAccountType[VismaBankAccountType["CurrencyAccount"] = 4] = "CurrencyAccount";
    VismaBankAccountType[VismaBankAccountType["DigitalWalletAccount"] = 5] = "DigitalWalletAccount";
    VismaBankAccountType[VismaBankAccountType["CashCreditAccount"] = 6] = "CashCreditAccount";
    VismaBankAccountType[VismaBankAccountType["TaxAccount"] = 7] = "TaxAccount";
})(VismaBankAccountType = exports.VismaBankAccountType || (exports.VismaBankAccountType = {}));
var VismaAccountType;
(function (VismaAccountType) {
    VismaAccountType[VismaAccountType["Standard"] = 1] = "Standard";
    VismaAccountType[VismaAccountType["Invoicing"] = 2] = "Invoicing";
    VismaAccountType[VismaAccountType["Bookkeeping"] = 3] = "Bookkeeping";
    VismaAccountType[VismaAccountType["Start"] = 4] = "Start";
    VismaAccountType[VismaAccountType["Pro"] = 5] = "Pro";
    VismaAccountType[VismaAccountType["InvoicingCollaboration"] = 6] = "InvoicingCollaboration";
})(VismaAccountType = exports.VismaAccountType || (exports.VismaAccountType = {}));
//# sourceMappingURL=visma.js.map